import validate from "/home/vsts/work/1/s/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/home/vsts/work/1/s/src/middleware/01.auth.global.ts";
import _02_45links_45customer_45global from "/home/vsts/work/1/s/src/middleware/02.links_customer.global.ts";
import _03_45permission_45check_45global from "/home/vsts/work/1/s/src/middleware/03.permission_check.global.ts";
import _05_45wizard_45global from "/home/vsts/work/1/s/src/middleware/05.wizard.global.ts";
import _06_45meta_45global from "/home/vsts/work/1/s/src/middleware/06.meta.global.ts";
import _07_45pdp_45shortlink_45global from "/home/vsts/work/1/s/src/middleware/07.pdp_shortlink.global.ts";
import _08_45old_45category_45urls_45global from "/home/vsts/work/1/s/src/middleware/08.old_category_urls.global.ts";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45links_45customer_45global,
  _03_45permission_45check_45global,
  _05_45wizard_45global,
  _06_45meta_45global,
  _07_45pdp_45shortlink_45global,
  _08_45old_45category_45urls_45global
]
export const namedMiddleware = {}